import Section from "@/components/ui/section";
import { QUERY_ALL_BLOGS } from "@/framework/queries/blogs";
import { sanitize } from "@/framework/utils/sanitize";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { useEffect, useState } from "react";
import { useQuery } from "urql";
export default function ReadMorePosts() {
  const [items, setItems] = useState([]);
  const [loadMoreData, setLoadMoreData] = useState(false);
  const [params, setParams] = useState({
    start: 0,
    limit: 10,
    sortBy: ["id:asc"],
    filter: {
      publishedAt: { ne: null },
      id: { gte: 50 },
    },
  });

  const [{ data, fetching: loading, error }] = useQuery({
    query: QUERY_ALL_BLOGS,
    variables: params,
  });

  useEffect(() => {
    if (data) {
      const newItems = data?.blogs?.data.map((row) => sanitize(row));
      if (!loadMoreData) {
        setItems(newItems);
      } else {
        setItems((prevItems) => [...prevItems, ...newItems]);
        setLoadMoreData(false);
      }
    }
  }, [data]);
  const handleLoadMore = () => {
    setLoadMoreData(true);
    setParams((prevParams) => ({
      ...prevParams,
      start: items?.length,
      limit: 10,
    }));
  };
  return (
    <Section>
      <div className="flex flex-col w-full gap-10 lg:max-w-[1920px] mx-auto">
        {/* <div className="w-full flex flex-col gap-2 border-b-[0.5px] border-darkGrey/50 pb-10 ">
          <p className="text-[#696765] md:text-lg text-base font-havletica">
            Read More
          </p>
          <p className="text-[#696765] font-light lg:max-w-[444px] leading-tight">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquam
            ipsa ut enim itaque! Commodi, beatae! Lore
          </p>
        </div> */}
        <div className="w-full flex flex-col gap-12 md:gap-10 overflow-hidden">
          {items.map((e, key) => {
            return <ReadingPost key={key} data={e} />;
          })}
          <button
            className="text-sm underline text-darkGrey hover:text-darkGrey/50 transition-all duration-300 ease w-fit mt-4 mx-auto"
            onClick={handleLoadMore}
          >
            Load More
          </button>
        </div>
      </div>
    </Section>
  );
}
const ReadingPost = ({ data }) => {
  console.log(data);
  const {
    publication,
    publicationTitle,
    description,
    link,
    excerpt,
    blog_categories,
    coverImage,
    title,
    slug,
  } = data;

  return (
    <div className="flex flex-col md:flex-row w-full border-b-[0.5px] border-darkGrey/50 last:border-b-0 md:pb-6 pb-8 md:gap-8">
      <Link
        href={"/blog-" + slug}
        className="flex items-start justify-start relative w-full md:w-[50%] shrink-0 lg:h-[25vw] md:h-[23vw] h-[200px] overflow-hidden mb-4 "
      >
        <Image
          src={
            coverImage?.data?.attributes?.formats?.medium?.url ??
            coverImage?.data?.attributes?.formats?.large?.url ??
            coverImage?.data?.attributes?.url ??
            "/images/placeholder.svg"
          }
          alt={
            coverImage?.data?.attributes?.alternativeText ??
            title ??
            "blog-image"
          }
          sizes="(max-width: 479px) 500px, 100vw"
          fill
          className="w-full h-full object-cover"
        />
        <div className="absolute top-0 left-0 bg-black/30 w-full h-full" />
      </Link>
      <div className="w-full flex flex-col gap-2 justify-center lg:max-w-[500px]">
        <p className="text-sm text-darkGrey/70">{`${blog_categories?.data[0]?.attributes?.name} | By Admin`}</p>
        <p className="text-lg text-darkGrey/90 !leading-tight">{title}</p>
        <div
          className="text-sm text-darkGrey/80 font-light !leading-tight"
          dangerouslySetInnerHTML={{ __html: excerpt }}
        ></div>

        {slug && (
          <Link
            href={"/blog-" + slug}
            className="mt-4 cursor-pointer text-sm underline text-darkGrey hover:text-darkGrey/50 transition-all duration-300 ease w-fit"
          >
            Read Now
          </Link>
        )}
      </div>
    </div>
  );
};
